const Api = {
    path: '',

    post(uri, params) {
        return new Promise((resolve, reject) => axios.post(this.path + uri, params)
            .then(response => this.handleSuccess(response, resolve))
            .catch(error => this.handleReject(error, () => this.get(uri, params), reject)));
    },

    handleSuccess(response, resolve) {
        resolve(response.data);
    },

    handleReject(error, retry, reject) {
        if (error.response && error.response.status === 401) {
            reject({
                data: 'Access denied. Authentication required.',
                code: 401
            });
        } else {
            if (error.response) {
                reject({
                    data: error.response.data,
                    code: error.response.status
                });
            }
            else if (error.request) {
                reject({
                    data: 'Service not available (XHR)',
                    code: 503
                });
            }
            else {
                reject({
                    data: error.message,
                    code: 503
                })
            }
        }
    },
};

export default Api;


// WEBPACK FOOTER //
// ./resources/assets/js/services/api.js